(function() {
  var accountantMenu = {
    init: function() {
      var accountantMenuTop = 0;
      var accountantMenu = $('.accountant-menu');
      var mql = window.matchMedia("screen and (min-width: 1039px)");
      var headerMain = $('.header__main-wrapper');
      var mobileNav = $('.mobile-nav--switch');
      var accountantMenuHeight = accountantMenu.height();
      var accountantMenuBoxes = [];
      var isHashUrl = false;

      var setAccountantMenu =  function() {
        if (accountantMenuTop + 40 < $(window).scrollTop() && mql.matches) {
          accountantMenu.addClass('accountant-menu--fixed');
          //header
          headerMain.addClass('header__main-wrapper--opacity0');
          mobileNav.addClass('mobile-nav--hide');
        } else {
          accountantMenu.removeClass('accountant-menu--fixed');
          //header
          headerMain.removeClass('header__main-wrapper--opacity0');
          mobileNav.removeClass('mobile-nav--hide');
        }
      }

      var resizeOrientation = function(mql) {
        if (!mql.matches) {
          accountantMenu.removeClass('accountant-menu--fixed');
          $('body').css('padding-top', 0);
        }
      }

      var setAccountantMenuBoxes = function() {
        $('[data-menu-href]').each(function() {
          accountantMenuBoxes.push($(this));
        });
      }

      var setSelectedMenu = function() {
        for (var i = 0; i < accountantMenuBoxes.length; i++) {
          if (accountantMenuBoxes[i].offset().top - accountantMenuHeight - 70 < $(window).scrollTop()
              && accountantMenuBoxes[i].offset().top + accountantMenuBoxes[i].innerHeight() - accountantMenuHeight - 70 > $(window).scrollTop()) {
            selectMenu(accountantMenuBoxes[i].data('menuHref'));
          }
        }
      }

      var selectMenu = function(current) {
        $('.menu-fixed li').removeClass('menu-fixed__element--selected');
        $('.menu-fixed li a[href="#'+ current +'"]').parent().addClass('menu-fixed__element--selected');
      }

      var moveToMenu = function(objLink) {
        var hashLink;
        if (typeof(objLink) === 'object') {
          hashLink = objLink.attr('href').slice(1);
        } else {
          hashLink = objLink.slice(1);
        }

        var menuBox = $('[data-menu-href="' + hashLink + '"]');
        if (menuBox.length > 0) {
          $('html, body').stop(true, false).animate({ scrollTop: (menuBox.offset().top - accountantMenuHeight) }, 800, function() {
            document.location.hash = hashLink;
            selectMenu(hashLink);
          });
        } else {
          $('html, body').stop(true, false).animate({ scrollTop: 0 }, 800);
          history.pushState('', document.title, window.location.pathname);
          selectMenu(hashLink);
        }
      }

      mql.addListener(resizeOrientation);
      window.addEventListener('scroll', function() {
        setAccountantMenu();
        if (mql.matches) { setSelectedMenu() }
      });

      window.addEventListener('resize', function() {
        accountantMenuTop = $('.header__main-wrapper').height();
      });

      $(document).ready(function() {
        accountantMenuTop = $('.header__main-wrapper').height();
        setAccountantMenu();
        setAccountantMenuBoxes();

        if (document.location.hash !== '') { isHashUrl = true; }

        $('.x-one-page').click(function(e) {
          e.preventDefault();
          moveToMenu($(this));
        });
      });

      window.addEventListener('load', function() {
        if (isHashUrl) { moveToMenu(document.location.hash); }
      });
    }
  };

  $(document).ready(function() {
    if ($('.accountant-menu').length > 0) { accountantMenu.init(); }
  });
})();
